// extracted by mini-css-extract-plugin
export var fadeIn = "_mr-1";
export var modalContent = "_mr-3";
export var overlay = "_mr-0";
export var popoverContent = "_mr-2";
export var results = "_mr-5";
export var searchInputWrapper = "_mr-4";